/* eslint-disable prefer-promise-reject-errors */
const DEFAULT_TIMEOUT = 15000;

export default function fetchJSON(url, options = {}) {
  const {
    timeout = DEFAULT_TIMEOUT,
    signal: customSignal,
    ...fetchOptions
  } = options;

  let controller;
  let timer;
  let signal = customSignal;

  if (timeout && typeof AbortController !== 'undefined') {
    controller = new AbortController();
    signal = controller.signal;
    if (customSignal) {
      if (customSignal.aborted) {
        controller.abort();
      } else {
        customSignal.addEventListener('abort', () => controller.abort(), {
          once: true,
        });
      }
    }
    timer = setTimeout(() => {
      controller.abort();
    }, timeout);
  }

  return new Promise((resolve, reject) => {
    fetch(url, { ...fetchOptions, signal })
      .then((response) => {
        if (timer) clearTimeout(timer);
        if (response.status === 204) {
          resolve({});
          return;
        }

        const contentType = response.headers.get('content-type') || '';
        // application/json and any +json type, e.g. application/problem+json of the new API errors
        const isJSON = /[/+]json\b/i.test(contentType);
        if (!isJSON) {
          reject({
            message: 'Not a JSON format',
            response,
            status: response.status,
            originalResponse: response,
          });
          return;
        }

        if (!response.ok) {
          response.json().then(
            (data) =>
              reject({
                message: 'Not OK',
                response: data,
                status: response.status,
                originalResponse: response,
              }),
            () =>
              reject({
                message: 'Not OK',
                response: null,
                status: response.status,
                originalResponse: response,
              })
          );
          return;
        }

        response.json().then(
          (data) => resolve(data),
          (err) => reject(err)
        );
      })
      .catch((error) => {
        if (timer) clearTimeout(timer);
        const isTimeout =
          error &&
          (error.name === 'AbortError' ||
            (controller && controller.signal && controller.signal.aborted));
        if (isTimeout) {
          reject({
            message: `Request timed out after ${timeout}ms`,
            isTimeout: true,
            status: 408,
            originalError: error,
          });
          return;
        }
        reject({
          message: (error && error.message) || 'Network error',
          isNetworkError: true,
          status: 0,
          originalError: error,
        });
      });
  });
}
